module.exports = __webpack_public_path__ + "static/img/Apps_1_optimized.1c2de01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apps/Apps_1_optimized.png
// module id = QAup
// module chunks = 0